module.exports = __webpack_public_path__ + "static/img/product4.1a898e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product4.png
// module id = q+v1
// module chunks = 1